import React, { useState, useEffect } from 'react';
import { Link, useLocation } from "react-router-dom";
import { useUser } from '../UserContext.js';

const Navbar = () => {
    const user = useUser();
    const [navbarClass, setNavbarClass] = useState('open');
    const [arrowClass, setArrowClass] = useState('fa fa-arrow-left');
    const [display, setDisplay] = useState('none');
    const [current, setCurrent] = useState('Projects');
    const data = useLocation();

    useEffect(() => {
        const pathname = data.pathname || '/';
        if (pathname.startsWith('/projects')) {
            setCurrent('Projects');
        } else if (pathname.startsWith('/tutorial')) {
            setCurrent('Tutorial');
        } else {
            setCurrent('Projects');
        }
    }, [data]);

    useEffect(() => {
        if (user) {
            setDisplay('flex');
        } else {
            setDisplay('none');
        }
    }, [user]);

    function handleClick() {
        if (navbarClass === 'open') {
            setNavbarClass('close');
            setArrowClass('fa fa-arrow-right');
            return;
        }
        if (navbarClass === 'close') {
            setNavbarClass('open');
            setArrowClass('fa fa-arrow-left');
            return;
        }
    }

    function handleChange(name) {
        setCurrent(name);
    }

    return (
        <div className={navbarClass} style={{ display }}>
            <ul>
                <Navigation name='Projects' link='/projects' class='navbar-link-title'
                    current={current} handleChange={handleChange} />
                <Navigation name='Tutorial' link='/tutorial' class='navbar-link'
                    current={current} handleChange={handleChange} />
            </ul>
            <div onClick={handleClick}>
                <i className={arrowClass} aria-hidden="true"></i>
            </div>
        </div >
    )
}

export default Navbar;

const Navigation = (props) => {
    const [display, setDisplay] = useState('none');
    const [height, setHeight] = useState('');

    useEffect(() => {
        if (props.class === 'navbar-link-title')
            setHeight('80px');
    }, []);

    useEffect(() => {
        setDisplay(props.current === props.name ? 'flex' : 'none');
    }, [props.current]);

    return (
        <li style={{ height }}>
            <Link to={props.link} className={props.class}
                onClick={() => { props.handleChange(props.name) }}>
                {props.name}
                <span style={{ display }}>◂</span>
            </Link>
        </li>
    )
}
